import { render } from "./ManageFeatures.vue?vue&type=template&id=4455b002"
import script from "./ManageFeatures.vue?vue&type=script&lang=js"
export * from "./ManageFeatures.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__